/**
 * Styled Components - Created by david on 27/03/18.
 */
import styled from 'styled-components'
import AntdTabs from 'antd/lib/tabs'
import Select from 'antd/lib/select'
import Magnifier from 'react-magnifier'
import Collapse from 'antd/lib/collapse'
import {
  BLUE,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  GRAY_SOFT,
  GRAY_STRONG,
  GREEN,
  GREEN_SELECTED,
  ORANGE,
  ORANGE_SELECTED,
  WHITE,
  RED_TRANSPARENT,
  RED,
  RED_DARK,
  WHITE_TRANSPARENT,
  GRAY_DARK,
  GRAY,
  BLACK,
  GREEN_PAYDAY,
  BLACK_LABEL,
  GREEN_STATUS,
  BLUE_SOFT,
  GRAY_SKELETON,
  COLOR_IN_DESIGN,
  DARKER_GRAY,
  GRAY_SNOW,
  BLUE_LIGHT,
  WHITE_SMOKE
} from '../../theme/colors'
import TextArea from 'antd/lib/input/TextArea'
import Button from 'antd/lib/button'
import Upload from 'antd/lib/upload'
import Icon from 'antd/lib/icon'
import Tooltip from 'antd/lib/tooltip'
import Popover from 'antd/lib/popover'
import Spin from 'antd/lib/spin'
import DraggableModal from 'react-modal-resizable-draggable'
import { AVENIR_MEDIUM } from '../../theme/fonts'
import { Resizable } from 're-resizable'

const Panel = Collapse.Panel

interface RowProps {
  margin?: string
  borderBottom?: string
  paddingBottom?: string
  height?: string
  secondary?: boolean
  third?: boolean
  isAdmin?: boolean
  noMargin?: boolean
  marginTop?: boolean
  codeColor?: string
  backgroundColor?: string
  disabled?: boolean
  highlight?: boolean
  selected?: boolean
  hasPrints?: boolean
  hasComments?: boolean
}

interface ButtonWrapperProps {
  disabled: boolean
}

interface ColorProps {
  color?: string
  secondary?: boolean
}

export const Container = styled.div`
  background-color: ${WHITE};
  display: flex;
  flex-flow: column;
  @media (max-width: 1023px) {
    height: calc(100vh - 110px);
    position: relative;
    z-index: 11;
  }
  .flexible-modal-mask {
    z-index: 10;
    position: absolute;
    height: 100vh;
  }
`

export const CollapseWrapper = styled.div`
  display: none;
  z-index: 9;
  .ant-collapse .ant-collapse-item .ant-collapse-header {
    display: flex;
    flex-direction: row;
    color: ${WHITE};
    font-size: 12px;
    letter-spacing: 0.15px;
    line-height: 16px;
    padding: 14px 0 12px 0;
  }
  .ant-collapse {
    background-color: #343434;
    @media (max-width: 767px) {
      ${({ selected }: RowProps) => selected ? `
        border-top: none;
      ` : ''}
    }
  }
  .ant-collapse .ant-collapse-item {
    border-bottom: none;
    @media (max-width: 767px) {
      ${({ selected }: RowProps) => selected ? `
        border-bottom: none;
        z-index: 1;
        background: #343434;
        width: 100%;
        border-top: 1px solid #d9d9d9;
      ` : ''}
    }
  }
  .ant-collapse-item-active {
    display: block;
    position: fixed;
    left: 0;
    top: 0px;
    z-index: 1;
    width: 100vw;
    height: calc(100vh - 163px);
    background: ${WHITE};
    @media (max-width: 767px) {
      height: calc(100% - 85px);
    }
    .ant-collapse-header {
      background-color: #343434;
    }
    .counter {
      right: 40%;
    }
  }
  .ant-collapse-item .ant-collapse-header .arrow {
    display: none;
  }
  .ant-collapse-item-active .ant-collapse-header .arrow {
    position: absolute;
    left: 20px;
    display: inline-flex;
    border: 1px solid ${WHITE};
    height: 24px;
    align-items: center;
    width: 24px;
    justify-content: center;
    border-radius: 50%;
    color: ${WHITE};
    top: unset;
    bottom: 15px;
  }

  .ant-collapse-borderless .ant-collapse-item .ant-collapse-content {
    padding: 0 0 0 0;
  }
  .ant-collapse-content-active {
    @media (max-width: 767px) {
      height: calc(100% - 81px);
    }
  }
  @media (max-width: 1023px) {
    display: block;
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    z-index: 8;
  }
`

export const CollapseMobile = styled(Collapse)`
  display: flex;
  justify-content: space-evenly;
`

export const PanelMobile = styled(Panel)``

export const PanelTitle = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  width: 100%;
  flex-flow: column;
  justify-content: flex-end;
  height: 56px;
  color: ${WHITE};
  position: relative;
  @media(max-width: 546px) {
    font-size: 9px;
  }
`

export const MembersCountContainerMobile = styled.div`
  position: absolute;
  right: -1px;
  top: -4px;
`

export const MembersCountMobile = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${WHITE};
  border-radius: 50%;
  width: 15px;
  height: 15px;
  font-size: 8px;
  font-weight: 600;
`

export const PanelIcon = styled.img`
  max-width: 28px;
  width: 100%;
  margin-bottom: 8px;
  object-fit: contain;
  filter: ${({ selected }: RowProps) => selected ? 
    `grayscale(1) brightness(2.5) saturate(0) contrast(1)` : 'saturate(0) contrast(2) brightness(1.4)'
  };
`

export const CollapseStyled = styled(Collapse)`
  margin-bottom: 12px;
  &.ant-collapse .ant-collapse-item .ant-collapse-header {
    display: flex !important;
    flex-direction: row !important;
    color: ${GRAY_DARK} !important;
    font-size: 14px !important;
    letter-spacing: 0.15px !important;
    line-height: 16px !important;
    padding: 0 !important;
    max-width: 136px !important;
    width: 100% !important;
  }
  &.ant-collapse .ant-collapse-item {
    border-bottom: none !important;
  }
  .ant-collapse-item .ant-collapse-header .arrow {
    position: absolute !important;
    left: calc(100% + 16px) !important;
    display: inline-flex !important;
    border: 1px solid ${BLUE} !important;
    height: 24px !important;
    align-items: center !important;
    width: 24px !important;
    justify-content: center !important;
    border-radius: 50% !important;
    color: ${BLUE} !important;
    bottom: 0 !important;
    line-height: 46px !important;
    vertical-align: top !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    font-style: normal !important;
    text-align: center !important;
    text-transform: none !important;
    text-rendering: optimizeLegibility !important;
  }
  .ant-collapse-item .ant-collapse-content-box {
    padding: 0 !important;
    padding-top: 12px !important;
  }
  .ant-collapse-content-active {
    height: auto !important;
  }
  .ant-collapse-item {
    border-bottom: none !important;
    z-index: 1 !important;
    background: ${WHITE} !important;
    width: auto !important;
    border-top: none !important;
    .ant-collapse-header {
      background-color: ${WHITE} !important;
    }
  }
  .ant-collapse-item-active {
    display: unset !important;
    position: unset !important;
    left: unset !important;
    top: unset !important;
    z-index: 1;
    width: auto !important;
    height: unset !important;
    background: ${WHITE} !important;
    @media (max-width: 767px) {
      height: unset !important;
    }
    .ant-collapse-header {
      background-color: ${WHITE} !important;
    }
    .counter {
      right: unset !important;
    }
  }
  &.ant-collapse {
    background-color: ${WHITE} !important;
    border-top: none !important;
  }
`

export const PanelDiv = styled(Panel)`
  width: 100%;
  border-bottom: none !important;
`

export const ContainerError = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  justify-content: center;
  align-items: center;
`

export const LayoutLeft = styled.div``

export const LeftArrow = styled(Icon)`
  margin-right: 10px;
`

export const WarningIcon = styled(Icon)`
  margin-right: 8px;
  color: ${ORANGE};
`

export const ApprovedIcon = styled(Icon)`
  margin-right: 8px;
  color: ${GREEN};
`

export const BlackBar = styled.div`
  background: var(--neutral-darkest);
  color: ${WHITE};
  display: flex;
  height: 38px;
  justify-content: center;
  padding: 0 28px;
  align-items: center;
  z-index: 3;
  @media (max-width: 1023px) {
    display: none;
  }
`

export const BlackBarMobile = styled.div`
  background: var(--neutral-darkest);
  color: ${WHITE};
  display: none;
  height: 38px;
  justify-content: space-between;
  padding: 0 12px;
  align-items: center;
  margin-top: 2px;
  z-index: 3;
  @media (max-width: 1023px) {
    display: flex;
  }
`

export const JakrooProDesign = styled.img`
  max-width: 112px;
  object-fit: contain;
  width: 100%;
`

export const BackButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 28px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 1023px) {
    left: 18px;
  }
`

export const RequestsTitle = styled.div`
  font-size: 12px;
  color: ${GRAY_DARK};
  display: flex;
  justify-content: flex-end;
  margin-top: -18px;
  margin-bottom: 28px;
  font-weight: bold;
  align-items: center;
`

export const AvailableLabel = styled.div``

export const AvailableCircle = styled.div`
  background: ${GRAY_DARK};
  width: 26px;
  height: 26px;
  margin-left: 12px;
  display: flex;
  font-size: 14px;
  justify-content: center;
  border-radius: 50%;
  align-items: center;
  color: ${WHITE};
`

export const StatusLabel = styled.div`
  background: ${({ color }: ColorProps) => color || GRAY_STRONG};
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 12px;
  position: absolute !important;
  top: 12px;
  right: 28px;
  padding: 9px;
  height: auto;
  color: white;
  font-weight: bold;
  max-width: 142px;
  text-align: center;
  width: 100%;
`

export const WhatsThis = styled.div`
  font-size: 10.5px;
  color: ${BLUE};
  position: absolute;
  font-weight: normal;
  font-family: Avenir;
  bottom: -22px;
  left: 0;
  width: 100%;
  text-transform: none;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const StatusTitle = styled.div`
  font-size: 17px;
  font-weight: 900;
  font-family: Avenir-Medium;
  text-align: center;
  margin-bottom: 24px;
  @media (max-width: 1023px) {
    color: ${WHITE};
  }
`

export const StatusSubTitle = styled.div`
  margin-bottom: 28px;
  padding: 0 10px;
  @media (min-width: 1441px) {
    font-size: 16px;
  }
  @media (min-width: 1800px) {
    font-size: 18px;
  }
  @media (max-width: 1023px) {
    color: ${WHITE};
  }
`

export const StatusCardsSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 28px;
  padding: 0 10px;
  @media (max-width: 1023px) {
    color: ${WHITE};
    flex-flow: column;
  }
`

export const StatusCard = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid ${GRAY_LIGHT};
  border-top: none;
  margin-right: 12px;
  min-height: 451px;
  &:last-child {
    margin-right: 0px;
  }
  @media (min-width: 1441px) {
    min-height: 471px;
  }
  @media (max-width: 1023px) {
    display: none;
  }
`

export const StatusCardMobile = styled.div`
  display: none;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  @media (max-width: 1023px) {
    display: flex;
  }
`

export const StatusMobileBody = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 16px;
  margin-bottom: 26px;
`

export const StatusCardLabel = styled.div`
  color: white;
  background: ${({ color }: ColorProps) => color || GRAY_STRONG};
  width: calc(100% + 2px);
  height: 31px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-weight: bold;
  font-family: Avenir;
  font-size: 12px;
  @media (min-width: 1441px) {
    font-size: 13px;
  }
  @media (min-width: 1800px) {
    font-size: 14px;
    height: 35px;
  }
`

export const StatusImage = styled.img`
  max-width: 188px;
  width: 100%;
  margin: 32px 0;
  padding: 0 11px;
  @media (max-width: 1023px) {
    background: ${WHITE};
    border-radius: 14px;
    max-width: 115px;
    margin: 0;
    margin-right: 10px;
  }
  @media (max-width: 640px) {
    max-width: 100px;
  }
`

export const StatusDescription = styled.div`
  padding: 0 14px;
  @media (min-width: 1024px) {
    font-size: 11px;
  }
  @media (min-width: 1441px) {
    font-size: 14px;
  }
  @media (min-width: 1800px) {
    font-size: 15px;
  }
  @media (max-width: 1023px) {
    color: ${WHITE};
  }
`

export const ArrowStatus = styled.img`
  max-width: 24px;
  margin-right: 12px;
  align-self: center;
  margin-bottom: 78px;
  @media (max-width: 1023px) {
    display: none;
  }
`

export const BottomSectionStatus = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex-flow: column;
  align-items: center;
`

export const ArrowLong = styled.img`
  max-width: 265px;
  margin-top: -24px;
  @media (max-width: 1023px) {
    display: none;
  }
`

export const CloseButtonStatus = styled.div`
  border: 1px solid ${GRAY};
  padding: 10px 12px;
  border-radius: 8px;
  margin-top: 17px;
  font-size: 12px;
  color: ${GRAY_STRONG};
  box-shadow: 0px 2px 4px -1px ${GRAY};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (min-width: 1024px) {
    display: none;
  }
  @media (max-width: 1023px) {
    box-shadow: none;
    border: 1px solid ${WHITE};
    color: ${WHITE};
    background: ${BLACK};
    margin-top: 0px;
  }
`

export const PrintPreviewLabel = styled.div`
  z-index: 8;
  max-width: 88px;
  width: 100%;
  padding: 8px;
  background: #f5f5f5;
  border-radius: 5px;
  box-shadow: 1px 1px 3px 0px #a7a7a7;
  transition: all .25s;
  ${({ selected }: RowProps) => selected ? `
    box-shadow: inset 1px 1px 4px 0px #9f9f9f;
    background: #ebebeb;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
  @media (max-width: 768px) {
    top: 128px;
    max-width: 76px;
  }
  animation: fade-in-right 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const PrintPreviewIcon = styled.img`
  max-width: 70px;
`

export const LockHdr = styled.div`
  right: 0px;
  position: absolute;
  top: 148px;
  z-index: 8;
  padding: 6px;
  background: #f5f5f5;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  box-shadow: 1px 1px 3px 0px #a7a7a7;
  transition: all .25s;
  ${({ selected }: RowProps) => selected ? `
    box-shadow: inset 1px 1px 4px 0px #9f9f9f;
    background: #ebebeb;
  ` : ''}
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
  @media (max-width: 768px) {
    top: 128px;
    max-width: 76px;
  }
  animation: fade-in-right 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const LockHdrImage = styled.img`
  max-width: 32px;
`

export const PrintZipLabel = styled.div`
  z-index: 8;
  max-width: 88px;
  width: 100%;
  right: 0px;
  position: absolute;
  top: 142px;
  padding: 8px;
  padding-left: 7px;
  background: ${WHITE};
  border-radius: 5px;
  border-top-right-radius: 0px
  border-bottom-right-radius: 0px
  box-shadow: 1px 1px 3px 0px #a7a7a7;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
  @media (max-width: 768px) {
    top: 187px;
    max-width: 98px;
  }
  animation: fade-in-right 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`

export const PrintZipIcon = styled.img`
  max-width: 76px;
  @media (max-width: 768px) {
    max-width: 84px;
  }
`

export const PreviewDiv = styled.div`
  z-index: 13;
  height: calc(100% - 72px);
  background: ${WHITE};
  top: 60px;
  padding: 32px 12px;
  padding-bottom: 8px;
  position: absolute;
  border-radius: 3px;
  box-shadow: 1px 2px 7px 0px #a7a7a7;
  transition: all .25s;
  display: ${({ selected }: RowProps) => selected ? 'auto' : 'none'};
  animation: fade-in-right 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(-20px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media (max-width: 1023px) {
    margin: 0 28px;
    max-height: calc(100% - 158px);
    height: auto;
  }
`

export const DownloadDiv = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  position: absolute;
  top: 14px;
  left: calc(50% - 50px);
  z-index: 17;
  color: ${BLUE};
  text-decoration: underline;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.5;
  }
`

export const DownloadIcon = styled(Icon)`
  margin-left: 6px;
`

export const CloseIcon = styled(Icon)`
  right: 15px;
  position: absolute;
  top: 15px;
  font-size: 16px;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 768px) {
    font-size: 20px;
  }
`

export const CloseModalIcon = styled(Icon)``

export const DesktopCloseButton = styled.div`
  font-size: 12px;
  box-shadow: -2px 2px 4px -1px #a7a7a7;
  transition: all .25s;
  position: absolute;
  top: -12px;
  right: -9px;
  border-radius: 100%;
  background: #4c4c4c;
  height: 28px;
  width: 28px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border: 1px solid #dbdbdb;
  color: ${WHITE};
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
  @media (max-width: 1023px) {
    display: none;
  }
  @media (max-width: 1042px) {
    right: 1px;
  }
  @media (min-width: 1441px) {
    font-size: 14px;
    height: 30px;
    width: 30px;
  }
  @media (min-width: 1800px) {
    font-size: 16px;
    height: 32px;
    width: 32px;
  }
`

export const PreviewImg = styled.img`
  height: 100%;
  object-fit: contain;
  width: 100%;
`

export const Layouts = styled.div`
  display: flex;
  @media (max-width: 1023px) {
    flex: 1;
  }
`

export const Variants = styled.div`
  display: flex;
  flex-flow: column;
  top: ${({ secondary }: RowProps) => secondary ? '158px' : '112px'};
  z-index: 4;
  left: 28px;
  position: absolute;
  @media (max-width: 1023px) {
    top: ${({ secondary }: RowProps) => secondary ? '190px' : '145px'};
    left: 18px;
  }
`

export const VariantButton = styled.img`
  width: 50px;
  object-fit: contain;
  max-height: 50px;
  border: 1px solid ${({ selected }: RowProps) => (selected ? RED : GRAY_LIGHT)};
  border-radius: 3px;
  transition: all 0.25s;
  padding: 5px;
  margin-bottom: 8px;
  background: ${WHITE};
  &:hover {
    cursor: pointer;
    background: ${GRAY_LIGHTEST};
  }
`

export const ChatCount = styled.div`
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  display: flex;
`

export const CountCircle = styled.div`
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 22px;
  font-size: 12px;
  border-radius: 50%;
  position: absolute;
  right: 0px;
  top: 6px;
  background: ${RED};
`

export const BottomSheetWrapper = styled.div`
  z-index: 8;
  .react-swipeable-view-container {
    box-shadow: rgba(0, 0, 0, 0.157) 0px -1px 5px !important;
  }
  @media (max-width: 1023px) {
    display: none;
  }
`

export const StyledTitle = styled.div`
  background-color: ${WHITE};
  padding: 16px 0;
  box-sizing: border-box;
  color: black;
  min-height: 64px;
  font-size: 24px;
  text-align: left;
  flex: 1;
  margin-left: 15px;
  cursor: pointer;
  color: ${BLUE};
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.23px;
  line-height: 25px;
  text-align: center;
`

export const DragIcon = styled(Icon)`
  display: flex;
  position: absolute;
  right: -5px;
  top: 50%;
  font-size: 12px;
  transform: rotate(45deg);
  background: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  z-index: 2;
  align-items: center;
  justify-content: center;
  color: gray;
  box-shadow: 1px 1px 4px -1px grey;
  cursor: col-resize;
`

export const StyledTabs = styled(AntdTabs)`
  text-align: center;
  width: 100%;
  box-shadow: 2px 0px 8px 0px ${GRAY_LIGHT};
  .ant-tabs-nav {
    width: 100%;
  }
  .ant-tabs-tab {
    width: ${({ hasPrints, hasComments }: RowProps) => {
        if (hasPrints && hasComments) {
          return '20%'
        } else if (hasPrints || hasComments) {
          return '25%'
        } else {
          return '33.33%'
        }
      }
    };
    margin: 0;
  }
  .ant-tabs-ink-bar {
    width: ${({ hasPrints, hasComments }: RowProps) => {
      if (hasPrints && hasComments) {
        return '20%'
      } else if (hasPrints || hasComments) {
        return '25%'
      } else {
        return '33.33%'
      }
    }
  };
  }
  .ant-tabs-bar {
    margin: 0;
  }
  @media (max-width: 1023px) {
    display: none;
  }
`

export const Title = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

export const Message = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 23px;
  text-align: center;
`

export const RenderContainer = styled.div`
  width: 600px;
  position: relative;
`

export const InfoDiv = styled.div`
  margin-right: ${({ isAdmin }: RowProps) => isAdmin ? '8px' : '0'};
  margin-left: ${({ isAdmin }: RowProps) => isAdmin ? '0' : '8px'};
  display: inline-flex;
  flex-flow: column;
`

export const RequestButtons = styled.div`
  display: flex;
  z-index: 7;
  position: absolute;
  max-width: 378px;
  width: 100%;
  bottom: 30px;
  align-items: center;
  justify-content: center;
  @media (max-width: 1023px) {
    display: none;
  }
`

export const PaidLabel = styled.div`
  background: ${({ secondary }: RowProps) => secondary ? '#9dd95b' : '#55c2eb'};
  color: ${WHITE};
  align-self: flex-start;
  padding: 2px 8px;
  margin-top: 6px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 3px;
  word-break: keep-all;
  transition: all .2s;
  max-width: 47px;
  width: 100%;
`

export const MobileRequestButtons = styled.div`
  display: none;
  bottom: 100px;
  position: fixed;
  left: 0;
  z-index: 8;
  width: 100%;
  padding: 0 28px;
  @media (max-width: 1023px) {
    display: flex;
  }
`

export const RequestEdit = styled(Button)`
  display: flex;
  height: 40px;
  flex-flow: column;
  border: 1px solid ${RED};
  width: ${({ secondary }: RowProps) => secondary ? '45%' : '90%'};
  padding: 4px;
  font-size: 12px;
  align-items: center;
  min-height: 42px;
  justify-content: center;
  border-radius: 3px;
  background: ${WHITE};
  transition: all .25s;
  &:hover {
    span {
      color: ${({ disabled }: RowProps) => disabled ? GRAY : WHITE};
    }
    cursor: pointer;
    background: ${RED};
    color: ${WHITE};
  }
  @media (max-width: 1023px) {
    height: auto;
  }
`

export const StyledTooltip = styled(Popover)`
  z-index: 12;
  position: absolute;
  right: -28px
  bottom: 14px;
  @media (max-width: 1023px) {
    right: -4px;
    left: unset;
  }
`

export const StyledTooltipMobile = styled(Popover)`
  z-index: 12;
  right: 30px;
  top: -28px;
  position: absolute;
`

export const InfoIconMobile = styled(Icon)`
  font-size: 18px;
  color: ${BLUE};
  z-index: 20;
`

export const IconTitle = styled(Icon)`
  margin: 0 auto;
  color: ${BLUE};
  width: 100%;
  font-size: 21px;
  margin-top: -8px;
  display: block;
  margin-bottom: 17px;
`

export const TextBody = styled.div``

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  max-width: 376px;
  width: 100%;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const InfoIcon = styled(Icon)`
  margin-left: 9px;
  font-size: 16px;
  vertical-align: sub;
  color: ${BLUE};
  z-index: 20;
  &:hover {
    cursor: pointer;
  }
`

export const EditsLabel = styled.div``

export const RequestText = styled.span`
  color: ${({ secondary }: RowProps) => secondary ? GRAY : RED};
  transition: all .25s;
`

export const PurchaseButton = styled.div`
  display: flex;
  flex-flow: column;
  color: ${WHITE};
  width: 90%;
  padding: 14px 4px;
  font-size: 12px;
  margin-top: 12px;
  align-items: center;
  border-radius: 3px;
  background: ${RED};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${RED_DARK};
  }
`

export const ResizableStyled = styled(Resizable)`
  transition: ${({ secondary }: RowProps) => secondary ? 'all .3s' : 'unset'};
`

export const AssistLabel = styled.div`
  color: ${GRAY_SOFT};
  margin-top: -12px;
  margin-bottom: 12px;
  font-size: 13px;
  text-align: left;
`

export const EditRequest = styled.div`
  text-align: center;
  width: 100%;
  box-shadow: 2px 0px 8px 0px ${GRAY_LIGHT};
  height: calc(${({ height }: RowProps) => height ? `${height}px` : '100vh'} - 142px);
  padding: 16px 22px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, .5);
    box-shadow: 0 0 1px rgba(255, 255, 255, .3);
  }
  @media (max-width: 1023px) {
    display: none;
  }
`

export const ModalTitle = styled.div`
  font-weight: 900;
  font-size: 16px;
  font-family: ${AVENIR_MEDIUM};
  margin-bottom: 22px;
  cursor: move;
`

export const DraggableModalStyled = styled(DraggableModal)`
  z-index: 10;
  padding: 27px;
  border-radius: 3px;
  max-width: 612px;
  width: 100% !important;
  max-height: 440px;
  height: 100% !important;
  align-self: center;
  box-shadow: 0px 2px 7px 0px ${GRAY_DARK};
  .flexible-modal-drag-area {
    background: unset;
  }
  @media (max-width: 612px) {
    left: 0;
  }
`

export const DraggableModalStyledPrint = styled(DraggableModal)`
  z-index: 10;
  border-radius: 3px;
  max-width: 612px;
  padding: 14px 0px;
  width: 100% !important;
  max-height: 440px;
  height: 100% !important;
  align-self: center;
  box-shadow: 0px 2px 7px 0px ${GRAY_DARK};
  .flexible-modal-drag-area {
    background: unset;
  }
  @media (max-width: 612px) {
    left: 0;
  }
`

export const DragText = styled.div`
  font-size: 10px;
  margin-bottom: 5px;
  margin-top: -5px;
`

export const ButtonsModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${GRAY};
  padding: 2px 8px;
  margin-right: 18px;
  border-radius: 3px;
  font-size: 12px;
  color: ${GRAY_STRONG};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const OpenButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #83b0e4;
  padding: 2px 8px;
  border-radius: 3px;
  font-size: 12px;
  color: #6697cf;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const stylesDraggable = {
  top: 'calc(50vh - 183px)',
  left: 'calc(50vw - 306px)'
}

export const stylesDraggableMobile = {
  top: 'calc(50vh - 200px)',
  left: '0'
}

export const PromptTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  font-family: Avenir;
  margin-bottom: 10px;
  color: ${GRAY_DARK};
`

export const ModalSubtitle = styled.div`
  font-size: 12px;
  color: ${GRAY_DARK};
  margin: 16px 0;
`

export const ModalSubtitleLeft = styled.div`
  font-size: 12px;
  color: ${GRAY_DARK};
  margin: 16px 0;
  text-align: left;
`

export const ApprovalTitle = styled.div`
  background: ${GRAY_LIGHTEST};
  width: 108%;
  margin-left: -14px;
  padding: 8px 18px;
  text-align: left;
  font-weight: bold;
  font-size: 13px;
  @media (max-width: 1023px) {
    display: none;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100vw;
  background: ${WHITE_TRANSPARENT};
  height: 100vh;
  z-index: 3;
  justify-content: center;
  align-items: center;
`

export const DesignChat = styled.div`
  padding: 0 14px;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  flex: 1;
  @media (max-width: 1023px) {
    padding: 0;
    height: calc(100vh - 277px);
  }
`

export const TextAreaStyled = styled(TextArea)`
  border-radius: 3px;
  outline: none;
  box-shadow: none;
  resize: none;
  &:hover {
    border: 1px solid ${GRAY_LIGHT};
  }
  &:focus {
    border: 1px solid ${GRAY_LIGHT};
    outline: none;
    box-shadow: none;
    resize: none;
  }
  ${({ highlight }: RowProps) => highlight ? `
    animation: blink-3 0.75s 0.25s 2 ease-in-out;
    @keyframes blink-3 {
      0% {
        box-shadow: 0 0 0 0 #fd9b9b;
      }
      100% {
        box-shadow: 0 0 4px 16px #ffebeb24;
      }
    }
  ` : ''}
`

export const ButtonContainer = styled.div`
  margin-top: 22px;
  text-align: right;
  background: ${WHITE};
  position: sticky;
  bottom: -6px;
  float: right;
  border-radius: 13px;
`

export const StyledUpload = styled(Upload)`
  margin-bottom: 16px;
  .ant-upload-select-picture-card {
    border: 1px solid ${RED};
    max-width: 128px;
    width: 100%;
    height: 36px;
    background: ${WHITE};
    border-radius: 3px;
    @media (max-width: 767px) {
      width: 100%;
    }
  }
`

export const UploadButton = styled.div`
  color: ${RED};
  display: flex;
  align-items: center;
  font-size: 12px;
  justify-content: center;
`

export const StyledIcon = styled(Icon)`
  margin-right: 16px;
`

export const Clip = styled(Icon)`
  color: ${RED};
  margin-right: 12px;
`

export const FileLabel = styled.div`
  display: flex;
`

export const MessageFile = styled.div`
  display: flex;
  margin-top: 6px;
  font-size: 12px;
  color: ${BLUE};
  text-decoration: underline;
  align-self: ${({ isAdmin }: RowProps) => isAdmin ? 'flex-end' : 'flex-start'};
  &:hover {
    cursor: pointer;
  }
`

export const TypeLabel = styled.div`
  font-size: 10px;
  background: ${GREEN_PAYDAY};
  padding: 2px 8px;
  margin-top: 8px;
  color: white;
  border-radius: 3px;
`

export const FileName = styled.div`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const SaveButton = styled(Button)`
  border-radius: 2px;
  font-size: 12px;
  height: 34px;
  padding: 0 28px;
  margin-left: 4px;
  background: ${BLUE};
  color: ${WHITE};
  border: none;
`

export const CancelButton = styled(Button)`
  border-radius: 2px;
  font-size: 12px;
  height: 34px;
  padding: 0 28px;
  margin-right: 4px;
`

export const SaveButtonRequest = styled(Button)`
  border-radius: 25px;
  font-size: 12px;
  height: 34px;
  padding: 0 28px;
  margin-left: 4px;
  background: ${BLUE};
  color: ${WHITE};
  border: none;
`

export const CancelButtonRequest = styled(Button)`
  border-radius: 25px;
  font-size: 12px;
  height: 34px;
  padding: 0 28px;
  margin-right: 4px;
`

export const ChatMessages = styled.div`
  flex: 1;
  overflow-y: scroll;
  @media (min-width: 1024px) {
    max-height: calc(100% - 45px);
  }
  ${({ highlight }: RowProps) => highlight ? `
    animation: shake-horizontal 0.8s cubic-bezier(0.455, 0.030, 0.515, 0.955) 1s both;
    @keyframes shake-horizontal {
      0% {
        transform: translateY(45px);
        animation-timing-function: ease-in;
        opacity: 1;
      }
      24% {
        opacity: 1;
      }
      40% {
        transform: translateY(24px);
        animation-timing-function: ease-in;
      }
      65% {
        transform: translateY(12px);
        animation-timing-function: ease-in;
      }
      82% {
        transform: translateY(6px);
        animation-timing-function: ease-in;
      }
      93% {
        transform: translateY(4px);
        animation-timing-function: ease-in;
      }
      25%,
      55%,
      75%,
      87% {
        transform: translateY(0px);
        animation-timing-function: ease-out;
      }
      100% {
        transform: translateY(0px);
        animation-timing-function: ease-out;
        opacity: 1;
      }
    }
  ` : ''}
`

export const IncomingMessage = styled.div`
  margin: 18px 0;
  display: flex;
  align-items: flex-start;
  flex-flow: ${({ isAdmin }: RowProps) => isAdmin ? 'row' : 'row-reverse'};
`

export const MessageHeader = styled.div`
  display: flex;
  margin-top: 4px;
  align-items: center;
  margin-right: ${({ isAdmin }: RowProps) => isAdmin ? '14px' : '0'};
  margin-left: ${({ isAdmin }: RowProps) => isAdmin ? '0' : '14px'};
`

export const TabContent = styled.div`
  display: flex;
  height: calc(${({ height }: RowProps) => height ? `${height}px` : '100vh'} - 215px);
  flex-flow: column;
`

export const LayoutRight = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  justify-content: center;
  background: ${({ color }: ColorProps) => color || 'radial-gradient(white, #fcfcfc, #f0f0f0, #e7e7e7)'};
  ${({ secondary }: ColorProps) => secondary ? `
    color: white;
    .modelDiv {
      div {
        color: white;
      }
      img {
        filter: brightness(2);
      }
    }
  ` : ''};
  #tagId {
    font-size: 14px;
    position: absolute !important;
    bottom: 202px;
    padding: 12px;
    height: auto;
    color: white;
    font-weight: bold;
    max-width: 342px;
    text-align: center;
    width: 100%;
    background: #c04646a8;
    border: none;
    z-index: 2;
    #clsIco {
      font-size: 8px;
      background: white;
      border-radius: 25px;
      padding: 1px 3px;
      position: absolute;
      right: 4px;
      top: 4px;
      color: #737373;
      cursor: pointer;
    }
  }
`

export const Products = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: center;
  flex-wrap: wrap;
  align-items: flex-start;
  ${({ secondary }: RowProps) => secondary ? `
    height: calc(100vh - 310px);
    overflow-y: scroll;
  ` : ''}
`

export const ProjectDesign = styled.div`
  display: flex;
  position: relative;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  margin-left: 22px;
  z-index: 3;
  margin-bottom: 24px;
  transition: all .2s;
  opacity: 1;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  &:first-child {
    margin-left: 0;
  }
`

export const ProStatus = styled.div`
  width: 85%;
  padding: 8px 0;
  font-size: 10px;
  text-align: center;
  font-weight: bold;
  text-transform: uppercase;
  background: ${BLACK_LABEL};
  border-radius: 3px;
  color: ${({ backgroundColor }: RowProps) => backgroundColor || WHITE};
`

export const ProLabel = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  position: absolute;
  width: 100%;
  top: 32%;
`

export const DesignImage = styled.img`
  object-fit: cover;
  max-width: 130px;
  height: 130px;
  background: ${GRAY_LIGHTEST};
`

export const DesignName = styled.div`
  margin-top: 18px;
  font-weight: bold;
  margin-bottom: 8px;
  font-size: 12px;
  color: ${({ secondary }: RowProps) => secondary ? GRAY_SOFT : GRAY_DARK};
`

export const ProductName = styled.div`
  font-size: 12px;
  text-transform: uppercase;
`

export const FullTitle = styled.div`
  background: ${({ secondary }: RowProps) => secondary ? GREEN_STATUS : ORANGE};
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 10px 4px;
  font-size: 14px;
  color: ${WHITE};
  font-weight: bold;
`

export const PromptBody = styled.div`
  margin-top: 32px;
  text-align: center;
  margin-left: -32px;
`

export const PromptSubtitle = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`

export const PromptLink = styled.div`
  margin-top: 20px;
  color: ${BLUE};
  font-weight: bold;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${BLUE_SOFT};
  }
`

export const PrompText = styled.div`
  margin-bottom: 20px;
`

export const PromptPrint = styled.div``

export const buttonPrompt = {
  background: WHITE,
  color: GRAY_STRONG,
  boxShadow: 'none',
  textShadow: 'none',
  borderColor: GRAY_SOFT,
  fontSize: '12px',
}

export const ApproveButton = styled(Button)`
  padding: 9px;
  width: 90%;
  height: 40px;
  margin-right: 30px;
  border-radius: 2px;
  color: white;
  background: ${BLUE};
  border: 0;
  border: 1px solid ${BLUE};
  transition: all .25s;
  &:hover {
    border: 1px solid ${BLUE};
    background: ${WHITE};
    color: ${BLUE};
  }
  @media (max-width: 1023px) {
    height: auto;
  }
`

export const AddToStoreButton = styled(Button)`
  padding: 9px;
  width: 100%;
  max-width: 184px;
  height: 40px;
  margin-left: 30px;
  border-radius: 3px;
  color: ${BLUE};
  background: ${WHITE};
  border: 0;
  border: 1px solid ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: ${BLUE};
    border-color: ${BLUE};
    color: ${WHITE};
  }
  @media (max-width: 1023px) {
    height: auto;
  }
`

export const RenderSection = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-bottom: 28px;
  height: calc(100% - 140px);
  margin-top: 88px;
  #render2D {
    max-width: 628px;
    height: fit-content;
  }
  @media (max-width: 1023px) {
    #render2D {
      max-width: 100vw;
      padding-inline: 14px;
    }
    margin-bottom: 168px;
    height: calc(100% - 257px);
  }
`

export const Initials = styled.div`
  width: 24px;
  font-size: 12px;
  height: 24px;
  background: ${BLUE};
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`

export const UserName = styled.div`
  margin-left: 12px;
  font-weight: bold;
`

export const DateMessage = styled.div`
  color: ${GRAY_SOFT};
  font-size: 9px;
  text-align: right;
  margin-top: 6px;
  margin-right: 4px;
`

export const JakrooLogo = styled.img`
  width: 100%;
  object-fit: cover;
  border-radius: 50%;
`

export const UserIcon = styled(Icon)`
  color: ${WHITE};
`

export const MessageBox = styled.div`
  background: ${WHITE};
  padding: 8px;
  box-shadow: 0px 2px 7px 0px ${GRAY_LIGHT};
  display: inline-flex;
  flex-flow: column;
  border-radius: 5px;
  justify-content: space-between;
  align-items: flex-end;
  ${({ highlight }: RowProps) => highlight ? `
    animation: blink-1 1.5s 2s 2 ease-in-out;
    @keyframes blink-1 {
      0% {
        box-shadow: 0 0 0 0 #ff6a6a;
      }
      100% {
        box-shadow: 0 0 0 16px #ffebebb8;
      }
    }
  ` : ''}
`

export const ParentText = styled.div`
  border-left: 2px solid ${({ codeColor }: RowProps) => codeColor || RED_TRANSPARENT};
  padding: 4px 10px;
  border-radius: 4px;
  margin-bottom: 10px;
  font-size: 12px;
  color: ${GRAY_STRONG};
  background: ${GRAY_LIGHTEST};
  text-align: left;
`

export const MessageBody = styled.div`
  display: inline-flex;
  text-align: start;
  width: 100%;
  word-break: break-word;
  flex-flow: column;
`

export const MessageComment = styled.div`
  display: inline-flex;
  text-align: start;
  width: 100%;
  word-break: break-word;
  flex-flow: column;
  min-width: 164px;
`

export const Accesories = styled.div`
  margin: 12px;
`

export const ColorsList = styled.div`
  margin-top: 14px;
  display: flex;
  flex-wrap: wrap;
`

export const Color = styled.div`
  min-height: 30px;
  height: 100%;
  width: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-right: 10px;
  border: 1px solid
    ${({ color }: ColorProps) =>
    color && color.toLowerCase() !== WHITE.toLowerCase() ? color : GRAY};
  background-color: ${({ color }: ColorProps) => color || WHITE};
  align-self: center;
`

export const ColorContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 18px;
  transition: all .25s;
  align-items: center;
  box-shadow: 1px 1px 5px -2px #585858;
  margin-bottom: 14px;
  border-radius: 5px;
  padding-right: 8px;
  min-width: 148px;
`
export const ColorName = styled.p`
  margin: 0;
  font-size: 11px;
  text-align: center;
  word-break: break-all;
  width: calc(100% - 40px);
`

export const Colors = styled.div`
  padding: 0 10px;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  flex: 1;
  overflow-y: scroll;
`

export const ColorBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 23px;
  margin-left: 12px;
  @media (max-width: 480px) {
    margin-left: 0px;
  }
`

export const CodeLabel = styled.div`
  background: ${({ codeColor }: RowProps) => codeColor || GRAY_DARK};
  color: ${WHITE};
  align-self: ${({ isAdmin }: RowProps) => isAdmin ? 'flex-end' : 'flex-start'};
  padding: 2px 8px;
  margin-top: 8px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 3px;
  word-break: keep-all;
  transition: all .2s;
  ${({ secondary }: RowProps) => secondary && `
    border: 1px solid ${({ codeColor }: RowProps) => codeColor || GRAY_DARK};
    &:hover {
      cursor: pointer;
      background: ${WHITE};
      color: ${GRAY_DARK};
    }
  `};
`

export const CodeColor = styled.div`
  font-weight: bold;
  font-size: 16px;
  letter-spacing: 0.23px;
  line-height: 25px;
  width: 100%;
  text-align: left;
`

export const MessageType = styled.div`
  text-transform: uppercase;
  color: ${({ secondary }: RowProps) => secondary ? ORANGE : GREEN};
  background: ${({ secondary }: RowProps) => secondary ? ORANGE_SELECTED : GREEN_SELECTED};
  padding: 0 8px;
  font-size: 12px;
  display: flex;
  font-weight: bold;
  border-radius: 2px;
  align-items: center;
  margin-left: ${({ isAdmin }: RowProps) => !isAdmin ? '0' : '6px'};
  margin-right: ${({ isAdmin }: RowProps) => !isAdmin ? '6px' : '0'};
  max-height: 22px;
`

export const RequiredText = styled.div`
  font-size: 10px;
  font-style: italic;
  max-width: 43px;
  width: 100%;
  font-weight: bold;
  color: ${BLUE};
  padding: 2px;
  &:hover {
    cursor: pointer;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 28px;
  top: 12px;
  z-index: 4;
  @media (min-width: 768px) and (max-width: 991px) {
    width: 25%;
  }

  @media (max-width: 1024px) {
    left: 18px;
    top: 14px;
  }
`

export const BottomButtons = styled.div`
  display: flex;
  z-index: 7;
  position: absolute;
  max-width: 378px;
  width: 100%;
  bottom: 30px;
  align-items: center;
  justify-content: center;
  @media (max-width: 1023px) {
    bottom: 100px;
    position: fixed;
    left: 0;
    z-index: 8;
    width: 100%;
    padding: 0 28px;
  }
`

export const NameLabel = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 22px;
  align-items: center;
  flex-flow: row;
  position: absolute;
  width: 100%;
  @media (min-width: 1024px) and (max-width: 1176px) {
    flex-flow: column;
  }
  @media (max-width: 767px) {
    right: 30px;
    flex-flow: column;
    top: 36px;
    align-items: flex-end;
    width: auto;
  }
`

export const DesignLabel = styled.div`
  display: flex;
  font-weight: bold;
  text-transform: uppercase;
  &:last-child {
    margin-left: 24px;
  }
  @media (max-width: 1024px) {
    margin-left: 0px;
  }
`

export const DescLabel = styled.div`
  font-weight: normal;
  margin-right: 10px;
`

export const ModelTitle = styled.div`
  color: ${GRAY_DARK};
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  user-select: none;
`

export const RowTitle = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 12px;
`

export const QuickView = styled.img`
  cursor: pointer;
  margin-left: 8px;
`

export const InfoText = styled.div`
  margin-left: -38px;
  margin-bottom: 4px;
`

export const EditSquares = styled.div`
  display: flex;
  flex-flow: column;
  right: 0px;
  position: absolute;
  top: 78px;
  animation: fade-in-left 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-left {
    0% {
      transform: translateX(-10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media (max-width: 1023px) {
    top: 100px;
  }
`

export const EditTitle = styled.div`
  font-weight: bold;
  margin-bottom: 10px;
`

export const Squares = styled.div`
  display: flex;
`

export const EditSquareDiv = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
`

export const UsedSquare = styled.div`
  width: 32px;
  height: 32px;
  font-weight: bold;
  color: white;
  background: #55c2eb;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const AvailableSquare = styled.div`
  width: 32px;
  height: 32px;
  font-weight: bold;
  color: #464646;
  background: ${({ secondary }: RowProps) => secondary ? '#f9c2c2' : '#e1e1e1'};
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const LabelSquare = styled.div`
  margin-top: 8px;
  font-size: 10px;
  font-weight: bold;
`

export const ButtonWrapper = styled.div`
  margin-bottom: ${({ noMargin }: RowProps) => noMargin ? 'unset' : '16px'};
  margin-top: ${({ marginTop }: RowProps) => marginTop ? '-4px' : 'unset'};
  .ant-btn-primary  {
    background-color: ${({ secondary }: RowProps) => secondary ? WHITE : BLUE};
    border-color: ${({ secondary }: RowProps) => secondary ? GRAY_STRONG : BLUE};
    width: 78px;
    color: ${({ selected }: RowProps) => selected ? WHITE : GRAY_DARK};
  }
  .ant-btn-primary:hover {
    background-color: ${({ secondary }: RowProps) => secondary ? GRAY_LIGHT : BLUE};
    border-color: ${({ secondary }: RowProps) => secondary ? GRAY_LIGHT : BLUE};
  }
`

export const okButtonStyles = {
  background: BLUE,
  border: 'none',
  borderRadius: '2px'
}

export const FileContainer = styled.div`

`

export const DeleteFile = styled(Icon)`
  color: ${RED};
  margin-left: 10px;
  padding-top: 2px;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`

export const Collaboration = styled.div`
  padding: 0 14px;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  flex: 1;
  font-family: Avenir;
  overflow-y: scroll;
  overflow-x: hidden;
  @media (max-width: 1023px) {
    padding: 0;
    height: calc(100vh - 210px);
  }
`

export const CollabInfo = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  margin-top: 14px;
`

export const CollabTitle = styled.div`
  text-align: left;
  font-weight: bold;
`

export const CollabDescription = styled.div`
  text-align: left;
  margin-top: 8px;
`

export const AddMemberButton = styled.div`
  padding: 6px 12px;
  border-radius: 4px;
  background: rgb(68, 104, 249);
  margin-top: 12px;
  color: ${WHITE};
  min-width: 136px;
  transition: all .25s;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  ${({ disabled }: RowProps) => disabled ? `
    background: ${GRAY_LIGHT};
    &:hover {
      opacity: 1;
      cursor: not-allowed;
    }
  ` : ''}
`

export const CollabMembers = styled.div`
  margin-top: 22px;
  padding-top: 22px;
  border-top: 1px solid ${GRAY_SKELETON};
`

export const MembersList = styled.div`
  margin-top: 24px;
  @media (max-width: 1023px) {
    max-width: 472px;
    width: 100%;
  }
`

export const Member = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 24px;
  position: relative;
`

export const MemberImage = styled(Icon)`
  background: ${({ codeColor }: RowProps) => codeColor || COLOR_IN_DESIGN};
  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  font-size: 20px;
  margin-right: 18px;
  opacity: 0.75;
  color: ${WHITE};
  @media(max-width: 767px) {
    font-size: 16px;
    padding: 10px;
  }
`

export const MemberData = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-flow: column;
  align-items: flex-start;
  font-size: 12px;
  flex: 1;
`

export const MemberName = styled.div`
  font-weight: bold;
  text-align: left;
`

export const MemberEmail = styled.div`
  text-align: left;
  word-break: break-all;
  margin-right: 6px;
`

export const MemberDate = styled.div`
  color: ${DARKER_GRAY};
  text-align: left;
  font-size: 11px;
`

export const MemberType = styled(Select)`
  min-width: 108px;
  margin-right: 10px;
  font-size: 12px;
`

export const BaseColorSelector = styled(Select)`
  min-width: 118px;
  margin-right: 10px;
  font-size: 12px;
  .ant-select-selection--single {
    height: 26px;
  }
  .ant-select-selection__rendered {
    margin-left: 0px;
    margin-right: 0px;
    line-height: 26px;
  }
  .ant-select-selection-selected-value {
    padding-right: 0px;
    width: 100%;
  }
  .ant-select-arrow {
    color: black;
    background: #ffffff8c;
    border-radius: 25px;
    padding: 0px 3px;
    margin-right: -7px;
    margin-top: -7px;
    padding-top: 3px;
    font-size: 10px;
  }
`

export const MemberDelete = styled(Icon)`
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: ${RED};
  }
`

export const PendingDiv = styled.div`
  display: flex;
  margin-top: 2px;
`

export const PendingLabel = styled.div`
  font-style: italic;
  color: ${RED};
`

export const Resend = styled.div`
  margin-left: 32px;
  color: ${BLUE};
  font-weight: bold;
  transition: all .25s;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
  }
`

export const InviteContainer = styled.div`
  margin: 22px 20px;
  font-family: Avenir;
  @media (max-width: 560px) {
    margin: 22px 0;
  }
`

export const InviteTitle = styled.div`
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
`

export const MailsContainer = styled.div`
  margin-top: 22px;
`

export const EmailsLabel = styled.div`
  font-weight: bold;
`

export const StyledEmailTags = styled.div`
  margin-top: 16px;
  border: 1px solid #d4d5d6;
  padding: 10px 8px;
  border-radius: 5px;
  min-height: 100px;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  &:hover {
    cursor: text;
  }
  .input {
    display: inline-block;
    width: ${({ secondary }: RowProps) => secondary ? 'auto' : '100%'};
    height: 28px;
    flex: 1;
    box-sizing: border-box;
    font: inherit;
    border-radius: 0.2rem;
    border: none;
    color: #565656;
    -webkit-appearance: none;
  }

  .input:focus {
    border-color: cornflowerblue;
    outline: none;
  }

  .input.has-error {
    border-color: tomato;
  }

  .input:disabled {
    background: unset;
  }

  .error {
    margin: 0;
    font-size: 90%;
    color: tomato;
  }

  .tag-item {
    background-color: #d4d5d6;
    display: inline-block;
    font-size: 12px;
    border-radius: 30px;
    height: 30px;
    padding: 0 4px 0 1rem;
    display: inline-flex;
    align-items: center;
    margin: 0 0.3rem 0.3rem 0;
    &:hover {
      cursor: default;
    }
  }

  .tag-item > .button {
    background-color: white;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    font: inherit;
    margin-left: 10px;
    font-weight: bold;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const SendInvitationButton = styled.div`
  display: inline-block;
  padding: 10px 18px;
  border-radius: 4px;
  background: rgb(68, 104, 249);
  margin-top: 18px;
  color: ${WHITE};
  transition: all .25s;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  ${({ disabled }: RowProps) => disabled ? `
    background: ${GRAY_LIGHT};
    &:hover {
      opacity: 1;
      cursor: not-allowed;
    }
  ` : ''}
`

export const BottomSection = styled.div`
  display: none;
  align-items: center;
  justify-content: space-between;
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid ${GRAY_LIGHT};
`

export const InviteLink = styled.div`
  display: flex;
  font-weight: bold;
  align-items: center;
`

export const InviteLinkLabel = styled.div`
  margin-left: 10px;
  transition: all .25s;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
    text-decoration: underline;
  }
`

export const CopyLinkButton = styled.div`
  display: inline-block;
  padding: 6px 10px;
  font-size: 12px;
  border-radius: 4px;
  color: rgb(68,104,249);
  background: ${WHITE};
  border: 1px solid rgb(68,104,249);
  transition: all .25s;
  &:hover {
    background: rgb(68,104,249);
    color: ${WHITE};
    cursor: pointer;
  }
`

export const GearIcon = styled(Icon)`
  color: ${BLACK};
  transition: all .25s;
  &:hover {
    opacity: 0.5;
    cursor: pointer;
    text-decoration: underline;
  }
`

export const InfoIconLink = styled(Icon)`
  margin-left: 10px;
  color: ${GRAY};
`

export const ConfirmEmailTags = styled.div`
  margin: 20px 0;
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  flex-wrap: wrap;
  max-height: 256px;
  .tag-item {
    background-color: #d4d5d6;
    display: inline-block;
    font-size: 12px;
    border-radius: 30px;
    height: 30px;
    padding: 0 4px 0 1rem;
    display: inline-flex;
    align-items: center;
    margin: 0 0.3rem 0.3rem 0;
    &:hover {
      cursor: default;
    }
  }

  .tag-item > .button {
    background-color: white;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    font: inherit;
    margin-left: 10px;
    font-weight: bold;
    padding: 0;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`

export const InfoConfirmation = styled.div`
  margin: 0 4px;
`

export const ConfirmBottom = styled.div`
  display: flex;
`

export const CancelInvitation = styled.div`
  margin-top: 18px;
  margin-left: 16px;
  display: flex;
  align-items: center;
  padding: 7px 18px;
  border-radius: 4px;
  color: rgb(68,104,249);
  background: ${WHITE};
  border: 1px solid rgb(68,104,249);
  transition: all .25s;
  &:hover {
    background: rgb(68,104,249);
    color: ${WHITE};
    cursor: pointer;
  }
`

export const StyledSpinInvitation = styled(Spin)`
  width: 79px;
  height: 15px;
`

export const CollabWarning = styled.div`
  text-align: left;
  color: red;
  margin-top: 4px;
`

export const MemberOwnerLabel = styled.div`
  font-weight: bold;
  flex: 1;
  text-align: center;
  padding: ${({ secondary }: RowProps) => secondary ? '0px' : '8px'};
  font-size: 12px;
`

export const StarIcon = styled(Icon)`
  position: absolute;
  left: 30px;
  bottom: 0;
  color: #ffca00;
  z-index: 2;
  @media(max-width: 767px) {
    left: 23px;
  }
`

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
`

export const PopoverText = styled.div`
  max-width: 256px;
  width: 100%;
  font-size: 12px;
  color: ${BLACK};
`

export const CommentSection = styled.div`
  padding: 0 14px;
  height: 100%;
  position: relative;
  display: flex;
  flex-flow: column;
  flex: 1;
  font-family: Avenir;
  @media (max-width: 1023px) {
    padding: 0;
    height: calc(100vh - 300px);
  }
`

export const ChatComments = styled.div`
  flex: 1;
  overflow-y: scroll;
  @media (min-width: 1024px) {
    max-height: calc(100% - 45px);
  }
  @media (max-width: 1023px) {
    padding-bottom: 38px;
  }
`

export const CommentMessage = styled.div`
  background: ${({ isAdmin }: RowProps) => isAdmin ? WHITE : '#fafff7'};
  padding: 8px;
  box-shadow: 0px 2px 7px 0px ${GRAY_LIGHT};
  display: inline-flex;
  flex-flow: column;
  border-radius: 5px;
  justify-content: space-between;
  align-items: flex-start;
  ${({ highlight }: RowProps) => highlight ? `
    animation: blink-1 1.5s 2s 2 ease-in-out;
    @keyframes blink-1 {
      0% {
        box-shadow: 0 0 0 0 #ff6a6a;
      }
      100% {
        box-shadow: 0 0 0 16px #ffebebb8;
      }
    }
  ` : ''}
`

export const MemberInitials = styled.div`
  width: 24px;
  font-size: 12px;
  height: 24px;
  background: ${({ codeColor }: RowProps) => codeColor || BLUE};
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`

export const CommentHeader = styled.div`
  margin-left: 2px;
  font-size: 14px;
  font-weight: bold;
  font-family: Avenir;
  margin-bottom: 4px;
  text-align: left;
  color: ${({ codeColor }: RowProps) => codeColor || BLUE};
  filter: contrast(0.5);
`

export const ImageMessage = styled.img`
  max-width: 100%;
  max-height: 278px;
`

export const ActionsIcons = styled.div`
  display: flex;
  margin-top: -11px;
  margin-left: 8px;
`

export const LikeAction = styled.div`
  margin-right: 14px;
  font-size: 12px;
`

export const HeartAction = styled.div`
  margin-right: 12px;
  font-size: 12px;
`

export const LikeIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 14px;
  color: ${BLUE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const HeartIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 14px;
  color: ${RED_TRANSPARENT};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CommentInput = styled.div`
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  align-items: flex-start;
  margin-left: -14px;
  margin-right: -14px;
  background: ${GRAY_SNOW};
  margin-top: 0px;
  margin-bottom: 0;
  min-height: 45px;
  padding: 6px 14px;
  flex-wrap: wrap;
  transition: all .4s;
  @media (max-width: 1023px) {
    position: fixed;
    bottom: 85px;
    width: 100vw;
  }
`

export const InputComment = styled(TextArea)`
  border-radius: 25px;
  outline: none;
  box-shadow: none;
  resize: none;
  &:hover {
    border: 1px solid ${GRAY_LIGHT};
  }
  &:focus {
    border: 1px solid ${GRAY_LIGHT};
    outline: none;
    box-shadow: none;
    resize: none;
  }
`

export const SendCommentButton = styled.div`
  font-family: Avenir-Medium;
  margin-left: 10px;
  color: ${({ disabled }: RowProps) => disabled ? GRAY : BLUE};
  transition: all .25s;
  &:hover {
    cursor: ${({ disabled }: RowProps) => disabled ? 'not-allowed' : 'pointer'};
    opacity: 0.7;
  }
`

export const ClipComment = styled(Icon)`
  margin-right: 10px;
  margin-bottom: 2px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const FullResponse = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex: 1;
`

export const AdvertisingComments = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: left;
  font-size: 12px;
  padding: 10px 14px;
  background: ${RED};
  color: ${WHITE};
  margin-left: -14px;
  margin-right: -14px;
  margin-top: -5px;
  margin-bottom: 7px;
`

export const CloseAdvertising = styled(Icon)`
  border: 1px solid ${WHITE};
  border-radius: 25px;
  padding: 4px;
  font-size: 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const FileComment = styled.div`
  display: flex;
  margin-top: 8px;
  align-items: center;
  text-decoration: underline;
  color: ${BLUE};
  width: 100%;
  margin-bottom: 6px;
  transition: all .25s;
`

export const ReplyComment = styled.div`
  text-align: right;
  width: 100%;
  margin-top: 6px;
  padding-right: 6px;
  font-size: 12px;
  color: ${BLUE};
  font-style: italic;
  font-family: Avenir-Medium;
  font-weight: 500;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ReplyIcon = styled(Icon)`
  margin-left: 6px;
`

export const RemoveParent = styled(Icon)`
  font-size: 12px;
  margin-left: 11px;
  flex: 1;
  text-align: left;
  margin-bottom: 4px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const UploadFileComment = styled(Upload)`
  .ant-upload-select-picture-card {
    border: none;
    width: auto;
    height: auto;
    margin: 0;
    @media (max-width: 767px) {
      width: 100%;
    }
  }
  span.ant-upload {
    padding: 0 !important;
    margin: 0 !important;
  }
  .ant-spin-spinning {
    margin-right: 10px !important;
  }
`

export const RemoveFileIcon = styled(Icon)`
  margin-left: 8px;
  color: ${RED};
  font-size: 11px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ScheduledDate = styled.div`
  width: fit-content;
  position: absolute;
  top: 11px;
  right: 180px;
  padding: 8px;
  background: ${WHITE};
  box-shadow: 0px 1px 3px 0px ${GRAY};
  border-radius: 6px;
  color: ${BLUE_LIGHT};
  font-weight: bold;
`

export const DateIcon = styled(Icon)`
  margin-right: 8px;
`

export const maskBlurred = {
  backdropFilter: 'blur(3px)'
}

export const buttonStyleModern = {
  background: '#3c3c3c',
  color: WHITE,
  borderColor: WHITE,
  boxShadow: 'none'
}

export const InfoBodyModern = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 18px 0px;
`

export const InfoImage = styled(Magnifier)`
  height: 100% !important;
  width: fit-content !important
  text-align: center;
  .magnifier-image {
    max-height: 100%;
    width: auto;
    background: #f3f3f3;
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
`

export const AdvertisingMouse = styled.div`
  position: absolute;
  background: #0000007a;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: Avenir;
  animation: fade-out 0.35s ease-out 0.75s both;
  @keyframes fade-out {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      visibility: hidden;
    }
  }
  @media (max-width: 1023px) {
    display: none;
  }
`

export const RejectTitle = styled.div`
  font-size: 17px;
  font-weight: bold;
  font-family: Avenir;
  text-align: center;
  margin-bottom: 22px;
`

export const RejectSubtitle = styled.div`
  margin-bottom: 12px;
`
export const RejectButton = styled(Button)`
  border-radius: 2px;
  font-size: 12px;
  height: 34px;
  padding: 0 28px;
  margin-left: 4px;
  border: none;
  opacity: 0.8;
`

export const BottomButtonsPrint = styled.div`
  display: flex;
  z-index: 7;
  position: absolute;
  width: 100%;
  bottom: 28px;
  gap: 8px;
  align-items: center;
  justify-content: center;
  flex-flow: column;
`

export const PrintsPending = styled.div`
  text-align: center;
  animation: fade-in 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) 2 both;
  @keyframes fade-in {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
`

export const ViewPrints = styled.div`
  background: ${BLUE};
  padding: 4px 12px;
  border-radius: 25px;
  color: ${WHITE};
  box-shadow: 0px 1px 4px 1px #c6c6c6;
  transition: all .25s;
  animation: wobble-hor-bottom 1s 0.5s 3 both;
  @keyframes wobble-hor-bottom {
    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}
    40% {transform: translateY(-15px);}
    60% {transform: translateY(-7px);}
  }
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ProTitle = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
`

export const ProCertification = styled.div`
  font-weight: bold;
  font-family: Avenir;
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const ProCertifyIconModal = styled(Icon)`
  margin-left: 12px;
  margin-top: -2px;
`

export const ProCertificationSub = styled.div`
  text-align: center;
`

export const GetYourDesigns = styled.div`
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 6px;
  font-family: Avenir;
`

export const PlanSelection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 12px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`

export const PlanDiv = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: flex-start;
  max-width: 366px;
  box-shadow: 0px 2px 7px 0px #bdbdbd;
  padding: 14px 28px;
  border-radius: 5px;
  position: relative;
  transition: all .3s;
  margin-right: 32px;
  min-height: 534px;
  border: ${({ secondary }: RowProps) => secondary ? `1px solid ${BLUE}` : ''};
  &:hover {
    cursor: pointer;
    box-shadow: 0px 2px 9px -1px #7f7f7f;
    transform: scale(1.007);
  }
  &:last-child {
    margin-right: 0px;
  }
  @media (max-width: 1024px) {
    margin-right: 0px;
  }
  @media (max-width: 768px) {
    margin-bottom: 28px;
    max-width: 378px;
    min-height: unset;
  }
`

export const MostPopular = styled.div`
  position: absolute;
  top: -12px;
  padding: 2px 8px;
  border-radius: 5px;
  background: #a2df84;
  color: #292929;
  font-size: 12px;
`

export const PlanTitle = styled.div`
  font-weight: bold;
  margin-top: 4px;
  margin-bottom: 20px;
  font-family: Avenir;
`

export const PriceDiv = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 12px;
  font-style: italic;
`

export const PriceValue = styled.div`
  font-size: 24px;
  margin-left: 26px;
  font-style: normal;
  font-weight: bold;
  font-family: Avenir;
  margin-right: 6px;
`

export const PlanDescription = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  font-size: 12px;
  margin-top: 20px;
`

export const DescriptionEntry = styled.div``

export const CheckIcon = styled(Icon)`
  margin-right: 8px;
  color: ${GREEN};
`

export const PlanImages = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  flex: 1;
  justify-content: center;
`

export const PlanPicture = styled.img`
  max-width: 138px;
`

export const PlanImage = styled.img`
  max-width: 57px;
  margin-top: 16px;
  margin-bottom: 21px;
  @media (max-width: 698px) {
    max-width: 50px;
  }
`

export const PlanDetails = styled.ul`
  padding-left: 23px;
  font-size: 12px;
  background: #fffaec;
  padding-top: 10px;
  padding-bottom: 12px;
  padding-right: 18px;
  border-radius: 3px;
  li {
    margin-bottom: 8px;
  }
`

export const BottomActions = styled.div`
  display: flex;
  align-items: flex-end;
`

export const EmptyCircle = styled.div`
  height: 18px
  width: 18px;
  border: 2px solid ${GRAY};
  border-radius: 25px;
  margin-top: 10px;
  transition: all .25s;
  &:hover {
    color: ${BLUE};
  }
`

export const SelectButton = styled(Icon)`
  font-size: 18px;
  margin-top: 10px;
  color: ${BLUE};
`

export const BottomButtonsPrintModal = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 20px;
  margin-bottom: 0;
  margin-top: 32px;
  align-items: center;
  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: space-between;
  }
`

export const InfoPrint = styled.div`
  color: ${BLUE};
  text-decoration: underline;
  transition: all .25s;
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  margin-top: 14px;
  margin-bottom: 24px;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 698px) {
    margin-bottom: 24px;
  }
`

export const RightButtons = styled.div`
  display: flex;
`

export const NoThanks = styled(Button)`
  box-shadow: 0px 1px 4px -1px silver;
`

export const ContinueButton = styled(Button)`
  margin-left: 20px;
  box-shadow: 0px 1px 3px 0px silver;
  color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? GRAY_LIGHT : WHITE};
  background-color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? WHITE_SMOKE : BLUE};
  border-color: ${({ disabled }: ButtonWrapperProps) =>
    disabled ? WHITE_SMOKE : BLUE};

  &:hover {
    background-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
    border-color: ${({ disabled }: ButtonWrapperProps) =>
      disabled ? WHITE_SMOKE : BLUE};
  }
`

export const ImageDiv = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DaysAmount = styled.div`
  position: absolute;
  font-weight: bold;
  color: black;
  font-size: 16px;
`

export const ModalTitleDisabled = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const IconPrint = styled(Icon)`
  margin-right: 12px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 12px;
  margin-left: -38px;
`

export const InfoSection = styled.div`
  display: flex;
  margin-bottom: 28px;
  @media (max-width: 698px) {
    flex-flow: column;
    align-items: center;
  }
`

export const DescriptionSection = styled.div`
  margin-left: 32px;
  @media (max-width: 698px) {
    margin-left: 0px;
    margin-top: 20px;
  }
`

export const InfoImageModal = styled.img`
  max-width: 220px;
  border-radius: 3px;
`

export const InfoSub = styled.div`
  font-size: 14px;
  font-family: Avenir;
`

export const SmallInfo = styled.div`
  font-size: 11px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  font-family: Avenir;
  margin-bottom: 18px;
`

export const GoodReasons = styled.div`
  font-weight: bold;
  font-family: Avenir;
  margin: 12px 0;
`

export const ReasonsList = styled.div`
  font-size: 14px;
  font-family: Avenir;
  ul {
    padding-left: 18px;
  }
  li {
    margin-bottom: 8px;
  }
`

export const buttonStyle = {
  background: BLUE,
  border: 'none',
}

export const EditContent = styled.div`
  margin: 22px 0 28px -38px;
  text-align: center;
`

export const TitleEdit = styled.div`
  text-align: center;
  font-weight: bold;
  font-family: Avenir;
`

export const BackgroundTips = styled.div`
  z-index: 8;
  max-width: ${({ secondary }: RowProps) => secondary ? '176px' : '36px'};
  width: 100%;
  right: 0px;
  position: absolute;
  top: 200px;
  color: ${GRAY_DARK};
  display: flex;
  padding: 8px;
  height: ${({ third }: RowProps) => third ? '256px' : '186px'};
  background: #FFFFFF;
  border-radius: 5px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  box-shadow: 0px 1px 3px 0px #a7a7a7;
  display: flex;
  align-items: center;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: ${({ secondary }: RowProps) => secondary ? '1' : '0.7'};
  }
  @media (max-width: 1023px) {
    top: 250px;
  }
`

export const ArrowLeft = styled(Icon)`
  box-shadow: -2px 1px 3px -1px #bdbdbd;
  border-radius: 25px;
  padding: 3px;
  font-size: 12px;
  margin-left: -17px;
  background: white;
`

export const BackgroundLabel = styled.div`
  white-space: nowrap;
  transform: rotate(-90deg);
  position: relative;
  top: 44px;
  left: 0;
  width: 22px;
  font-family: Avenir;
  font-size: 13px;
  font-weight: 500;
`

export const BackgroundItem = styled.div`
  display: flex;
  margin-bottom: 5px;
  padding: 1px 10px;
  padding-right: 2px;
  border-radius: 25px;
  background: #f8f8f8;
  align-items: center;
  white-space: nowrap;
  &:last-child {
    margin-bottom: 0px;
  }
  &:hover {
    cursor: pointer;
    color: cornflowerblue;
  }
`

export const BackType = styled.div`
  background: url(${({ url }: { url: string }) => url});
  width: 156px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-size: cover;
  border-radius: 5px;
  color: white;
  margin: 12px 0;
  box-shadow: 1px 2px 4px -1px #646464;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const HdrDiv = styled.div`
  position: relative;
  margin-bottom: 10px;
  transition: all .25s;
  &.clear {
    box-shadow: 1px 2px 4px -1px #646464;
    border-radius: 5px;
    min-height: 58px;
    width: 100%;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const HdrThumbnail = styled.img`
  object-fit: cover;
  width: 156px;
  height: 58px;
  box-shadow: 1px 2px 4px -1px #646464;
  border-radius: 5px;
`

export const HdrLabel = styled.div`
  position: absolute;
  top: 0;
  padding: 2px;
  font-size: 12px;
  width: 100%;
  text-align: center;
  background: #00000052;
  color: white;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`

export const CheckHdr = styled(Icon)`
  position: absolute;
  color: lightgreen;
  z-index: 2;
  top: 2px;
  left: 2px;
`

export const LockHDRLabel = styled.div`
  display: inline;
  background: white;
  margin-top: -28px;
  color: black;
  padding: 12px 23px 12px 18px;
  margin-left: -40px;
  margin-right: -16px;
  z-index: 2;
  position: relative;
  border-radius: 5px;
  font-weight: bold;
  box-shadow: 0px 1px 5px 1px #000000;
`

export const AlertLabel = styled(Icon)``

export const CircleEmpty = styled.div`
  width: 10px;
  height: 10px;
  border: 1px solid gainsboro;
  border-radius: 50%;
  margin-left: -4px;
  margin-right: 6px;
  background: white;
`

export const CheckIcon2 = styled(Icon)`
  margin-left: -4px;
  margin-right: 6px;
  font-size: 10px;
  color: cornflowerblue;
`

export const BackgroundName = styled.div`
  font-family: Avenir;
  color: ${({ secondary }: RowProps) => secondary ? 'cornflowerblue' : 'auto'};
  font-size: 13px;
`

export const BackgroundPreview = styled.div`
  border-radius: 25px;
  width: 22px;
  height: 18px;
  border: 1px solid lightgray;
  margin-left: 10px;
  background: ${({ color }: ColorProps) => color || 'radial-gradient(white, #fcfcfc, #ebebeb, #d9d9d9)'};
`

export const DesiredLabel = styled.div`
  border-radius: 3px;
  padding: 0px 10px;
  text-align: left;
  font-weight: normal;
  font-size: 12px;
  color: ${({ color }: ColorProps) => color && color !== 'lightgray' ? 'white' : 'inherit'};
  background: ${({ color }: ColorProps) => color || 'lightgray'};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/DesignApproval/styledComponents.tsx